import {
  GET_THERMOMETER_INFOS_IN_PROGRESS,
  GET_THERMOMETER_INFOS_SUCCESS,
  GET_THERMOMETER_INFOS_FAIL,
  POST_THERMOMETER_IN_PROGRESS,
  POST_THERMOMETER_SUCCESS,
  POST_THERMOMETER_FAIL,
  PUT_THERMOMETER_IN_PROGRESS,
  PUT_THERMOMETER_SUCCESS,
  PUT_THERMOMETER_FAIL,
} from "../constants";

const initialState = {
  infos: undefined,
  saving: false,
  saved: false,
  errors: null,
};

/**
 * Thermometer reducer
 *
 * @param {Object} state
 * @param {Object} action
 *
 * @return {Object}
 */
export default function thermometer(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case GET_THERMOMETER_INFOS_IN_PROGRESS:
      return {
        ...state,
        infos: undefined,
      };

    case GET_THERMOMETER_INFOS_SUCCESS:
      return {
        ...state,
        infos: payload.infos,
      };

    case GET_THERMOMETER_INFOS_FAIL:
      return {
        ...state,
        infos: null,
      };

    case POST_THERMOMETER_IN_PROGRESS:
    case PUT_THERMOMETER_IN_PROGRESS:
      return {
        ...state,
        saving: true,
        saved: false,
        errors: null,
      };

    case POST_THERMOMETER_SUCCESS:
    case PUT_THERMOMETER_SUCCESS:
      return {
        ...state,
        saving: false,
        saved: true,
      };

    case POST_THERMOMETER_FAIL:
    case PUT_THERMOMETER_FAIL:
      return {
        ...state,
        saving: false,
        saved: false,
        errors: payload.violations,
      };

    default:
      return state;
  }
}
